import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { communicationAPI } from 'api/communicationAPI';
import CloseIcon from 'assets/images/icon/CloseIcon';
import DeleteRedIcon from 'assets/images/icon/DeleteRedIcon';
import EditIcon from 'assets/images/icon/EditIcon';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { FaUser } from 'react-icons/fa6';
import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import { CheckBox } from 'view/components/common/CheckBox';

const arr = [1, 2, 3, 4, 5];

const QnApopup = (props) => {
    const [ratingValue, setRatingValue] = useState(0);
    const [selectItem, setSelectItem] = useState(null);
    const [status, setStatus] = useState(false);
    const [qnaData, setQnaData] = useState(null);
    const [feedback, setFeedback] = useState("");
    const mouseOver = (index) => {
        setRatingValue(index);
    };
    const returnData = (date) => {
        // const c = cloneDeep(date)?.map((item, index) => {
        //     if (index === 1) {
        //         item = item - 1;
        //     }
        //     return item;
        // });
        // let ms = dayjs(Date.UTC.apply(null, c?.slice(0, 6)))
        //     .utc()
        //     .locale("en")
        //     .format("MMM DD, YYYY");
        return date;
    };

    const getFormData = () => {
        const formData = new FormData();
        // formData.append("email", props?.userData?.email);
        formData.append("content", feedback);
        return formData;
    };

    const getQnaById = async () => {
        await communicationAPI.getQnAById(props?.data?.id).then((res) => {
            console.log("res", res);
            setQnaData(cloneDeep(res?.data));
        });
    };

    const putHomework = async () => {
        await communicationAPI
            .updateQna(props?.data?.id, {
                data: {
                    answer: feedback,
                    isCompleted: true,
                },
            })
            .then((res) => {
                console.log("suc", res);
                props.getData();
                getQnaById();
            });
    };

    const editQnaItem = async (id, value) => {
        await communicationAPI
            .editQna(props?.data?.id, id, {
                data: {
                    answer: value,
                    isCompleted: true,
                },
            })
            .then((res) => {
                props.getData();
                getQnaById();
            });
    };

    const deleteQnaItem = async (id) => {
        await communicationAPI.deleteQna(props?.data?.id,id)
        .then(res => {
            props.getData();
            getQnaById();
        })
    }

    const scrollContainerRef = useRef(null);

    useEffect(() => {
      // 스크롤 컨테이너에 접근
      const scrollContainer = scrollContainerRef.current;
  
      // 스크롤 컨테이너의 높이와 스크롤 높이를 확인하여 스크롤을 아래로 이동
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer?.scrollHeight;
      }
    }, [qnaData?.qna?.qnaComments]); // 컴포넌트가 처음 렌더링될 때만 실행

    useEffect(() => {
        getQnaById();
    }, []);

    console.log('selectItem', selectItem)
    console.log("@props?.data",qnaData);

    return (
        <Container>
            <Title>
                <h1>Your Feedback</h1>
                <CloseButton
                    onClick={() => {
                        props.onClickPopup();
                    }}
                >
                    <CloseIcon />
                </CloseButton>
            </Title>
            <div className={"wrap"} style={{ background: "#fff" }}>
                <Contents>
                    <TextArea>
                        <TextAreaContents>
                            <Avatar>
                            {
                                !isEmpty(props?.data?.user?.profileImage?.url) ?
                                <img src={
                                    props?.data?.user?.profileImage?.url ||
                                    "/images/userFeedback.png"} alt="" />
                                    :
                                    <FaUser />
                            }
                            </Avatar>
                            <TextWrap>
                                <span>
                                    {props?.data?.user?.lastName || "Test"}&nbsp;
                                    {props?.data?.user?.firstName || ""}
                                </span>
                                <b>{returnData(props?.data?.createdDatetime) || "JUL 18, 2024"}</b>
                            </TextWrap>
                        </TextAreaContents>
                    </TextArea>
                    <ContentsWrap style={{marginBottom:10}}>
                        <textarea readOnly={true} value={props?.data?.question || "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi fuga, mollitia nesciunt reiciendis sequi tempore? Aliquam architecto, assumenda commodi dignissimos laboriosam, maxime minima, praesentium provident quidem quos sed unde ut."}/>
                    </ContentsWrap>
                    {!isEmpty(qnaData?.qnA?.qnaComments) &&
                    <CommentsList ref={scrollContainerRef}>
                        {!isEmpty(qnaData?.qnA?.qnaComments) &&
                            qnaData?.qnA?.qnaComments?.map((item, index) => {
                                return (
                                    <CommentsItem>
                                        <CommentTitle>
                                            <TitleLeft>
                                                <User>
                                                    <img
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            objectFit: "cover",
                                                        }}
                                                        src={item?.teacher?.profileImage?.url || "/images/banner-publish.png"}
                                                        alt=""
                                                    />
                                                </User>
                                                <UserInfo>
                                                    <span style={{ fontSize: 16 }}>
                                                        {item?.teacher?.nickName}
                                                    </span>
                                                    <b style={{ fontSize: 12 }}>
                                                        {returnData(item?.updatedDatetime)}
                                                    </b>
                                                </UserInfo>
                                            </TitleLeft>
                                            <TitleRight>
                                                <div
                                                    onClick={()=>{
                                                        deleteQnaItem(item?.id, )
                                                    }}
                                                >
                                                    <DeleteRedIcon />
                                                </div>

                                                <div
                                                    onClick={() => {
                                                        if (
                                                            !isEmpty(selectItem) &&
                                                            selectItem?.id === item.id
                                                        ) {
                                                            const c = cloneDeep(qnaData);
                                                            editQnaItem(item?.id, c?.qnA?.qnaComments[index]?.answer)
                                                            setSelectItem(null);
                                                        } else {
                                                            setSelectItem(item);
                                                            getQnaById();
                                                        }
                                                       
                                                    }}
                                                >
                                                    <EditIcon />
                                                </div>
                                            </TitleRight>
                                        </CommentTitle>
                                        <Comments>
                                            <textarea
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const c = cloneDeep(qnaData);
                                                    c.qnA.qnaComments[index].answer = value;
                                                    setQnaData(c);
                                                }}
                                                readOnly={
                                                    !(
                                                        !isEmpty(selectItem) &&
                                                        selectItem?.id === item.id
                                                    )
                                                }
                                                className={
                                                    !isEmpty(selectItem) &&
                                                    selectItem?.id === item.id
                                                        ? "on"
                                                        : ""
                                                }
                                                value={item?.answer}
                                            ></textarea>
                                        </Comments>
                                    </CommentsItem>
                                );
                            })}

                    </CommentsList>
                    }

                </Contents>
                <InputItem>
                    <input
                        value={feedback}
                        onChange={(e) => {
                            setFeedback(e.target.value);
                        }}
                        placeholder="Answer"
                        type={"text"}
                        onKeyDown={async (e) => {                            
                            if (isEmpty(feedback) && status === false) return;
                            if(e.keyCode == 13){
                                await putHomework();
                            }
                        }}
                    />
                </InputItem>
                <Send>
                    <CheckBoxWrap>
                        <CheckBox
                            state={status}
                            onClick={() => {
                                setStatus((v) => !v);
                            }}
                        />
                        <p style={{ marginLeft: 5 }}>Mark as Complete</p>
                    </CheckBoxWrap>
                    <span
                        className={isEmpty(feedback) && status === false ? "off" : ""}
                     
                        onClick={async () => {
                            if (isEmpty(feedback) && status === false) return;
                            await putHomework();
                        }}
                    >
                        Send
                    </span>
                </Send>
            </div>
        </Container>
    );
};
export default QnApopup;

const Container = styled.div`
    width: 90%;
    max-width: 900px;
    overflow: hidden;
    border-radius: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    
    h1 {
        font-size: 28px;
        font-weight: 700;
    }
    .wrap{
        @media screen and (max-width: 768px) {
            max-height: 600px;
            overflow-y: scroll;
        }
        @media screen and (max-width: 468px) {
            max-height: 500px;
            overflow-y: scroll;
        }
    }
    @supports (-webkit-touch-callout: none) {
        top: 40%;

    }
`;

const InputItem = styled.div`
    display: flex;
    padding: 0 20px;
    margin-bottom: 10px;
    input {
        padding: 0 15px;
        font-size: 14px;
        &::placeholder {
            opacity: 0.5;
        }
        width: 100%;
        display: flex;
        height: 48px;
        border: solid 0.6px #333;
        border-radius: 6px;
        outline: none;
    }
`;

const Title = styled.div`
    height: 50px;
    justify-content: space-between;
    background: #333;
    padding-right: 17px;
    display: flex;
    align-items: center;
    padding-left: 17px;
    h1 {
        font-weight: 700;
        font-size: 22px;
        color: #ddc160;
    }
`;

const Dvider = styled.div`
    width: 100%;
    background: #333;
    opacity: 0.1;
    height: 1px;
`;

const CommentsList = styled.div`
    border-radius: 8px;
    max-height: 250px;
    border: solid 1px #3333333f;
    background: #f3f3f3;
    padding-bottom: 15px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;
const CommentsItem = styled.div`
    padding: 15px 15px 0 15px;
`;
const Comments = styled.div`
    margin-top: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    transition: all 0.2s;
    border-bottom: solid 1px #3333333e;
    textarea {
        transition: all 0.2s;
        background: #f3f3f3;
        resize: none;
        width: 100%;
        border-radius: 8px;
        padding: 0;
        line-height: 22px;
        font-size: 15px;
        border: none;
        outline: none;
        &.on {
            padding: 5px 10px;
            background: #fff;
            border: solid 1px #333;
        }
    }
    p {
        line-height: 22px;
    }
    padding-bottom: 10px;
    border-bottom: solid 0.6px #33333330;
`;
const CommentTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const User = styled.div`
    img {
        border-radius: 100%;
        margin-right: 10px;
    }
`;
const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
    span {
        color: #333;
        font-weight: 700;
        margin-bottom: 2px;
    }
    b {
        color: #bbb;
    }
`;
const TitleLeft = styled.div`
    display: flex;
    align-items: center;
    & > div {
        height: 100%;
        display: flex;
        align-items: center;
    }
`;
const TitleRight = styled.div`
    height: 40px;
    display: flex;
    align-items: center;
    svg {
        cursor: pointer;
        margin-left: 16px;
    }
`;
const Contents = styled.div`
    padding: 20px;
`;
const Avatar = styled.div`
    min-width: 50px;
    width: 50px;
    margin-right: 25px;
    svg {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background: #ddd;
        path {
            fill: #eee;
        }
    }
    img {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        object-fit: contain;
        min-width: 50px;
        min-height: 50px;
    }
`;
const TextArea = styled.div`
    flex: 1;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    h2 {
        line-height: 29px;
        padding: 15px;
        font-size: 22px;
        font-weight: 700;
    }
`;
const CloseButton = styled.div`
    background: #333;

    cursor: pointer;
    &:hover{
        svg{
            transition: all 0.2s;
            transform: scale(1.1);
        }
    }
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    svg {
        width: 30px;
        height: 30px;
    }
`;
const TextAreaContents = styled.div`
    display: flex;
    align-items: center;
`;
const TextWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 50px;

    span {
        font-size: 22px;
        font-weight: 600;
        line-height: 27.5px;
    }
    p {
        line-height: 28px;
        font-size: 18px;
        font-weight: 400;
    }
    b {
        opacity: 0.6;
        font-size: 14px;
        display: inline-block;
        margin-bottom: 4px;
        color: #33333399;
    }
`;
const Rating = styled.div`
    padding: 20px;
    width: 100%;
    h4 {
        font-size: 22px;
        margin-bottom: 15px;
    }
    textarea {
        background: #f5f5f5;
        border: solid 1px #33333330;
        border-radius: 15px;
        width: 100%;
        height: 150px;
        outline: none;
        resize: none;
        padding: 15px;

        
    }
`;
const RatingHeader = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    h2 {
        font-size: 22px;
        margin-right: 30px;
    }
    span {
        b {
            width: 12px;
            font-weight: 400;
        }
        display: flex;
        height: 100%;
        padding-top: 3px;
        width: 54px;
    }
`;
const Stars = styled.div`
    display: flex;

    align-items: flex-start;
`;
const Star = styled.div`
    display: flex;
    align-items: center;
    margin-right: 12px;
    cursor: pointer;
`;
const Send = styled.div`
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 27px;
    font-size: 18px;
    background: #fff;
    @media screen and (max-width: 468px) {
        font-size: 14px;
    }
    span {
        &.off {
            background: #ddd;
        }
        cursor: pointer;
        background: #ddc160;
        color: #fff;
        width: 134px;
        height: 40px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
    }
`;

const IconItem = styled.div`
    display: flex;
    padding-top: 8px;
    align-items: flex-start;
    margin-left: 20px;
    height: 60px;
    span {
        margin-left: 8px;
        padding-top: 4px;
    }
`;

const ContentsWrap = styled.div`
    max-height: 120px;
    height: 100px;
    //height: 120px;

    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #33333320 transparent;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
    textarea {
        border: none;
        height: 100%;
        width: 100%;
        resize: none;
        outline: none;
        color: #333;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        margin-bottom: 0;
        line-height: 28px;
        overflow-y: auto;
        position: relative;
    }
`;

const CheckBoxWrap = styled.div`
    display: flex;
    align-items: center;
`;
